import styled from 'styled-components';

export const DataTableContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.grayDivider};
  border-radius: 8px;
  padding: 32px 0;
  background: ${({ theme }) => theme.white};

  @media (max-width: 991px) {
    align-items: center;
  }
`;

export const DataTableLayoutHeader = styled.div`
    padding: 0 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 47px;
    @media (max-width: ${({theme}) => theme.breakpoints.md}) {
      margin-bottom: 27px;
      padding: 0 16px;
      flex-direction: column;
    }
`

export const DataTableLayoutTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  font-weight: 700;
  font-size: 19px;
  line-height: 23px;
  letter-spacing: 0.4px;
  color: ${({theme}) => theme.black};
  width: 100%;
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    font-size: 16px;
    margin-bottom: 16px;
  }
`

export const DataTableLayoutText = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  font-weight: 400;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.4px;
  color: ${({theme}) => theme.gray};
  width: 100%;
  padding: 0 32px;
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    font-size: 12px;
    margin-bottom: 16px;
  }
`

export const DataTableLayoutFilter = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  width: 100%;
`

export const DataTableLayoutFooter = styled.div`
    padding: 24px 30px 0 0;
    font-size: 14px;
    color: ${({theme}) => theme.gray}
    font-weight: 400;
    width: 100%;
    display: flex;
    justify-content: right;
`

export const TablePaddingContent = styled.div`
  padding: 0 32px;
`
export const NavigationButton = styled.button`
    all: unset;
    svg{
      //stroke:  !important;
      path{
        stroke: ${({theme}) => theme.grayLight};
        transition: all 300ms ease;
      }
    }
    :hover{
      svg{
        cursor: pointer;
        path{
          stroke: ${({theme}) => theme.gray}
        }
      }
    }
  :disabled{
    svg{
      path{
        stroke: ${({theme}) => theme.grayDivider};
      }
      :hover{
        stroke: ${({theme}) => theme.grayDivider};
        cursor: default;
      }
    }
  }
`

